import React__default from 'react';
import PropTypes from 'prop-types';

var propTypes = {
  /** Content displayed inside the accordion panel */
  children: PropTypes.node.isRequired,
  /** Sets the heading level for accessibility using aria-level */
  headingLevel: PropTypes.oneOf([2, 3, 4, 5, 6]).isRequired,
  /** Links the accordion header to its corresponding panel */
  id: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  /** Main title shown in the accordion header */
  title: PropTypes.node.isRequired,
  brand: PropTypes.oneOf(['', 'anf', 'kids', 'hol']),
  /** If true, the accordion content panel is expanded */
  isExpanded: PropTypes.bool,
  /** Sets data attribute for theming */
  theme: PropTypes.oneOf(['', 'primary-dark', 'primary-light', 'secondary-light']),
  /** Additional description shown under the title in the header */
  titleDescription: PropTypes.node,
  /** Variants change geometry and colors of the accordion */
  variant: PropTypes.oneOf(['', 'bordered', 'boxed', 'floating'])
};
function Accordion(_ref) {
  var brand = _ref.brand,
    children = _ref.children,
    headingLevel = _ref.headingLevel,
    isExpanded = _ref.isExpanded,
    id = _ref.id,
    onClick = _ref.onClick,
    theme = _ref.theme,
    title = _ref.title,
    titleDescription = _ref.titleDescription,
    variant = _ref.variant;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "accordion",
    "data-brand": brand || null,
    "data-brand-theme": theme || null,
    "data-expanded": isExpanded,
    "data-testid": "accordion",
    "data-type": variant
  }, /*#__PURE__*/React__default.createElement("div", {
    "aria-level": headingLevel,
    className: "heading",
    role: "heading"
  }, /*#__PURE__*/React__default.createElement("button", {
    "aria-controls": "".concat(id, "-panel-id"),
    "aria-expanded": isExpanded,
    className: "accordion-trigger",
    id: id,
    onClick: onClick,
    type: "button"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "accordion-title",
    "data-testid": "accordion-title"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "h3"
  }, title), titleDescription && /*#__PURE__*/React__default.createElement("span", {
    className: "accordion-description"
  }, titleDescription)), /*#__PURE__*/React__default.createElement("span", {
    "aria-hidden": "true",
    className: "accordion-icon",
    "data-icon": variant === 'floating' ? 'down-thin' : 'plus',
    "data-testid": "accordion-icon"
  }))), /*#__PURE__*/React__default.createElement("div", {
    "aria-hidden": !isExpanded,
    "aria-labelledby": id,
    className: "accordion-panel",
    "data-animated": "false",
    id: "".concat(id, "-panel-id"),
    role: "region"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "accordion-panel-content"
  }, children)), /*#__PURE__*/React__default.createElement("div", {
    className: "accordion-border",
    "data-testid": "accordion-border"
  }));
}
Accordion.propTypes = propTypes;

export { Accordion as default };
//# sourceMappingURL=Accordion.js.map
